export enum Theme {
  Light = 'LIGHT',
  Dark = 'DARK',
}
